(ns manage.product-selector-page.sections.key-matching
  (:require ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj ->js]]
            [common.form :as form]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [manage.product-selector-page.hooks :as hooks]
            [manage.product-selector-page.widgets :as widgets]
            [reagent.core :as r]
            [uix.core :refer [$ defhook defui]]))

(defhook use-keyword-clause-field-options []
  (let [field-options (hooks/use-field-options)]
    (->> field-options
         (filter #(= (:type %) "keyword"))
         (remove #(= (:name %) "sku"))
         (map #(hash-map :value (:name %)
                         :label (or (:label %)
                                    (:name %)))))))

(defui edit []
  (let [{:keys [control]} (form/use-form-context)
        {:keys [fields append remove]} (form/use-field-array #js {:control control
                                                                  :name "match"})
        ^js key-matching-field (first fields)]
    ($ form-field
       {:label "Product field"}
       (r/as-element
        [dropdown
         {:value (some-> key-matching-field .-field)
          :on-change (fn [value]
                       (remove 0)
                       (when value
                         (append (->js {:field value :source "hits" :from "first"}))))
          :options (use-keyword-clause-field-options)
          :placeholder "None"
          :clearable? true}]))))

(defui read []
  (let [{:keys [control]} (form/use-form-context)
        {:keys [field]} (->clj (rhf/useWatch #js {:name "match[0]" :control control}))]
    (if field
      ($ form-field
         {:label "Products only match the first product of key"}
         ($ :span field))
      ($ widgets/empty-section-message {:step-label "Key matching"}))))

(defui key-matching []
  (let [{:keys [mode]} (form/use-form-context)]
    ($ widgets/section-card
       {:title "Key matching"
        :tooltip "Select the primary key. Only products that match this key will be included."}
       (if (= mode :read)
         ($ read)
         ($ edit)))))
